/**
 * Validate input for required value.
 * @param {string} value input value.
 * @returns null if valid or Error object.
 */
function validateReqiured(value) {
    if (value.trim() === '') {
        return new Error('Это обязательное поле');
    }

    return null;
}

/**
 * Validate user name (like first name or last name).
 * @param {string} value input value.
 * @returns null if no errors or Error object with message.s
 */
function validateName(value) {
    const validRegex = /^[a-zA-Zа-яА-Яё\s\-]{2,}$/gi;

    if (!validRegex.test(value.trim())) {
        return new Error('Только буквы и не менее 2 символов');
    }

    return null;
}

/**
 * Validate phone number.
 * @param {string} value phone input value.
 * @returns null if no errors found or Error object with message.
 */
function validatePhone(value) {
    const validRegexAllCountries = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/gi;
    // const validRegex = /^((\+?7)|8)\d{10}$/gi;

    if (!validRegexAllCountries.test(value)) {
        return new Error('Недопустимый формат номера.');
    }

    return null;
}

/**
 * Validate email for errors.
 * @param {string} value Email input value.
 * @returns null if no errors found or Error object with message.
 */
function validateEmail(value) {
    if (value.trim() === '') return new Error('Необходимо указать Email');
    // Check for email correct
    const validRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!validRegex.test(value.toLowerCase())) {
        return new Error('Введите правильный Email');
    }

    // Return null if there are no errors.
    return null;
}

/**
 * Validate password for errors.
 * @param {string} password Password from input.
 * @returns null if no errors found or Error object with message.
 */
function validatePassword(password) {
    // Check for symbols
    const validRegex = /^([a-zA-Z0-9\+\_\-\$\&\(\)\^\*\%\#\@\!]+)$/g;

    if (!validRegex.test(password) && password.length > 0) {
        return new Error('Есть недопустимые символы');
    }

    // Minimum length
    if (password.length < 6) {
        return new Error('Минимум 6 символов');
    }

    // No errors
    return null;
}

/**
 * Validate number.
 * @param {strin} number Number value from input.
 * @param {number} min Minimum value.
 * @param {number} max Maximum value.
 * @returns null if no errors or Error object with message.
 */
function validateNumber(number, min, max) {
    const parsedNumber = Number(number);

    if (isNaN(parsedNumber)) {
        return new Error('Допустимы только числа');
    }

    if (parsedNumber < min) {
        return new Error('Не менее ' + min);
    }

    if (parsedNumber > max) {
        return new Error('Не более ' + max);
    }

    return null;
}

/**
 * Validate data string.
 * @param {string} value date input value.
 * @returns null if no errors found or Error object with message.
 */
function validateDate(value) {
    const validRegex = /^(\d{2}\.){2}\d{4}$/gi;

    if (validRegex.test(value)) {
        const [day, month, year] = value.split('.');
        const date = new Date(year + '/' + month + '/' + day);

        if (isNaN(date.getDate()) || day > 31 || day < 1 || month < 1 || month > 12 || year < 0) {
            return new Error('Укажите правильную дату.');
        }

        return null;
    }

    return new Error('Неправильный формат даты: дд.мм.гггг');
}

function validateLength(string, min = 0, max = Infinity, allowEmpty = false) {
    string = string.trim();

    if (string.length < min && !(allowEmpty && string.length === 0)) return new Error(`Минимум символов: ${min}`);
    else if (string.length > max) return new Error(`Максимум символов: ${max}`);

    return null;
}

/**
 * Validate string as custom ID. Strings of this type should contain only numbers and english letters.
 * @param {string} value string input value.
 * @returns null if no errors found or Error object with message.
 */
function validateID(value) {
    const validRegex = /^[a-zA-Z0-9]*$/gi;

    if (!validRegex.test(value)) {
        return new Error('Только латинские буквы и цифры');
    }

    return validateLength(value, 2, Infinity, true);
}

function validateTerminalKeyPass(value) {
    const validRegex = /^[a-zA-Z0-9\-\_]*$/gi;

    if (!validRegex.test(value)) {
        return new Error('Только латинские буквы и цифры');
    }

    return validateLength(value, 6, Infinity, false);
}

function validateInn(value) {
    const validRegex = /^[0-9]{10,}$/gi;

    if (!validRegex.test(value)) {
        return new Error('ИНН должен содержать, как минимум 10 цифр.');
    }

    return null;
}

function validateUrl(value) {
    const validRegex =
        /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

    if (!validRegex.test(value)) {
        return new Error('Указан некорректный URL');
    }

    return null;
}

export {
    validateReqiured,
    validateName,
    validatePhone,
    validateEmail,
    validatePassword,
    validateNumber,
    validateDate,
    validateID,
    validateTerminalKeyPass,
    validateInn,
    validateUrl,
};
